import React, { useEffect, Fragment } from 'react';
import { Spinner } from 'triider-components';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { routes } from 'config/routes';
import { Creators as UiCreators } from 'store/ducks/ui';
import { Creators as DashCreators } from 'store/ducks/dash';

import { gaSendEvent } from '../../../utils/analytics';

import {
  Container,
  TitleBox,
  Numbers,
  Icon,
  Number,
  Label,
  SeeMore,
  Section,
  Card,
  TitleCard,
  Bar,
  Name,
  Full,
  Progress,
  BoxLoader,
  ContainerEmpty,
  Gif,
  Title,
  Desc,
} from './styles';

const Dashs = ({
  isLoading, _getDash, userDashs, _push, // tasks, taskList,
}) => {
  useEffect(() => {
    _getDash();
  }, []);

  const goToTasks = (value) => {
    if (value === 'open,hired,charged') {
      gaSendEvent('meus_pedidos', 'status');
    }
    if (value === 'charged') {
      gaSendEvent('pagamentos_pendentes', 'status');
    }
    _push(routes.taskList, { name: 'status', value });
  };

  const NumberCharts = ({
    color, title, title1, title2, taskListlength, load, goToTasksFilter, isAmount, amount,
  }) => {
    if (isAmount) {
      const amountSplited = parseFloat(amount).toFixed(2).toString().split('.');
      return (
        <Numbers isAmount>
          { load ? (
            <BoxLoader>
              <Spinner size="small" />
            </BoxLoader>
          ) : (
            <Fragment>
              <Label isAmount>{title1}</Label>
              <Number isAmount>
                <span>R$ </span>
                {parseFloat(amountSplited[0]).toLocaleString('en').replace(/,/g, '.')}
                <span>
                  ,
                  {amountSplited[1]}
                </span>
              </Number>
              <Label isAmount>{title2}</Label>
            </Fragment>
          )}
        </Numbers>
      );
    }
    return (
      <Numbers onClick={() => goToTasks(goToTasksFilter)}>
        { load ? (
          <BoxLoader>
            <Spinner size="small" />
          </BoxLoader>
        ) : (
          <Fragment>
            <Icon color={color} />
            <Number>{taskListlength}</Number>
            <Label>{title}</Label>
            <SeeMore>{taskListlength > 0 ? 'Ver todos' : ''}</SeeMore>
          </Fragment>
        )}
      </Numbers>
    );
  };

  const ChartBar = ({ title, data, load }) => {
    if (load) {
      return (
        <Card>
          <BoxLoader>
            <Spinner size="small" />
          </BoxLoader>
        </Card>
      );
    }

    return (
      <Card>
        <TitleCard>{title}</TitleCard>
        {
          data ? data.map((item, i) => {
            const highest = Math.max(...data.map(s => s.total));
            const percent = `${item.total * 100 / highest}%`;
            if (i < 5) {
              return (
                <Bar key={i}>
                  <Name>{item.service_name || item.user_name && item.user_name.split(' ')[0]}</Name>
                  <Full><Progress percent={percent} /></Full>
                </Bar>
              );
            }
          }) : ''
        }
      </Card>
    );
  };

  const makeNumberCharts = (title, title2, color, amount, goToTasksFilter, taskListlength, isAmount) => (
    <NumberCharts
      isAmount={isAmount}
      title={title}
      title2={title2}
      color={color}
      amount={amount}
      goToTasksFilter={goToTasksFilter}
      taskListlength={taskListlength}
      load={isLoading}
    />
  );

  const {
    openedTasks, chargedTasks, last_month_expenses, current_month_expenses, services, users,
  } = userDashs;

  const renderDashs = () => (
    openedTasks || chargedTasks || last_month_expenses || current_month_expenses ? (
      <Container>
        {makeNumberCharts('Pedidos abertos', '', 'blue', '', 'open,hired,charged', openedTasks, false)}
        {makeNumberCharts('Pagamentos pendentes', '', 'green', '', 'charged', chargedTasks, false)}
        {makeNumberCharts('Você gastou', 'no mês passado', '', last_month_expenses || 0, '', null, true)}
        {makeNumberCharts('Você gastou', 'neste mês', '', current_month_expenses || 0, '', null, true)}
        <ChartBar
          title="Tipos de serviços:"
          data={services || []}
          load={isLoading}
        />
        <ChartBar
          title="Pedidos por atendentes:"
          data={users || []}
          load={isLoading}
        />
      </Container>
    ) : (
      <ContainerEmpty>
        <Gif />
        <Title>Você ainda não possui relatórios</Title>
        <Desc>Faça o seu primeiro pedido para começar a visualizar os seus dados.</Desc>
      </ContainerEmpty>
    )
  );

  return (
    <div>
      <TitleBox>Status</TitleBox>
      { isLoading ? (
        <Container>
          <BoxLoader>
            <Spinner size="larger" />
          </BoxLoader>
        </Container>
      ) : (
        renderDashs()
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  userDashs: state.dash.userDashs,
});

const mapDispatchToProps = {
  _push: push,
  _showLoader: UiCreators.showLoader,
  _hideLoader: UiCreators.hideLoader,
  _getDash: DashCreators.getDashRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Dashs);
